import apiClient from '@/api/apiClient'

export const getConversations = (accountId, params = {}) =>
  apiClient.get(`api/v1/accounts/${accountId}/conversations`, { params })

export const getConversation = (accountId, id) =>
  apiClient.get(`api/v1/accounts/${accountId}/conversations/${id}`)

export const getStats = accountId =>
  apiClient.get(`api/v1/accounts/${accountId}/conversations/stats`)

export const searchConversations = (accountId, params) =>
  apiClient.get(`api/v1/accounts/${accountId}/search`, { params })

export const exportConversation = (accountId, id) =>
  apiClient.get(`api/v1/accounts/${accountId}/conversations/${id}/export`, {
    responseType: 'blob',
  })

export const getMessages = (accountId, conversationId, params = {}) =>
  apiClient.get(
    `api/v1/accounts/${accountId}/conversations/${conversationId}/messages`,
    { params }
  )

export const createMessage = (accountId, conversationId, payload) =>
  apiClient.post(
    `api/v1/accounts/${accountId}/conversations/${conversationId}/messages`,
    payload
  )

export const sendTyping = (accountId, conversationId) =>
  apiClient.post(
    `api/v1/accounts/${accountId}/conversations/${conversationId}/typing`
  )

export const setStatus = (accountId, id, status) =>
  apiClient.post(`api/v1/accounts/${accountId}/conversations/${id}/status`, {
    status,
  })

export const transferConversation = (accountId, id, payload) =>
  apiClient.post(
    `api/v1/accounts/${accountId}/conversations/${id}/transfer`,
    payload
  )

export const setConversationTag = (accountId, id, tagId) =>
  apiClient.post(`api/v1/accounts/${accountId}/conversations/${id}/tag`, {
    tag_id: tagId,
  })

export const rateConversation = (accountId, id, payload) =>
  apiClient.post(`api/v1/accounts/${accountId}/conversations/${id}/rating`, {
    rating: payload,
  })

export const requestBlock = (accountId, id) =>
  apiClient.post(
    `api/v1/accounts/${accountId}/conversations/${id}/block_request`
  )

export const updateMessage = (accountId, conversationId, messageId, payload) =>
  apiClient.patch(
    `api/v1/accounts/${accountId}/conversations/${conversationId}/messages/${messageId}`,
    payload
  )

export const getDraft = (accountId, conversationId) =>
  apiClient.get(
    `api/v1/accounts/${accountId}/conversations/${conversationId}/draft`
  )

export const saveDraft = (accountId, conversationId, payload) =>
  apiClient.patch(
    `api/v1/accounts/${accountId}/conversations/${conversationId}/draft`,
    payload
  )

export const deleteDraft = (accountId, conversationId, params = {}) =>
  apiClient.delete(
    `api/v1/accounts/${accountId}/conversations/${conversationId}/draft`,
    { params }
  )
